import React, { useContext, useState, memo } from 'react';
import _ from 'lodash';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { Global } from '../../App';

/**
 *
 * @typedef {{title: string, langType: number}} item
 */
/**
 * @param {any} props
 * @param {item[]} props.options
 * @param {string} props.mode
 * @param {function} props.onClose
 *
 */

function StoreSelector({ options, mode, defaultOption, onSelect }) {
  const { globalState } = useContext(Global);
  const [toggle, setToggle] = useState(false);
  function handleMode(mode) {
    switch (mode) {
      case 'pc':
        return {
          borderTopLeftRadius: '6px',
          borderTopRightRadius: '6px',
          borderBottomLeftRadius: '6px',
          borderBottomRightRadius: '6px',
          backgroundColor: '#B69E60',
          border: 'none'
        };
      case 'mobile':
        return {
          borderRadius: '6px',
          backgroundColor: '#B69E60',
          border: 'none'
        };
      default:
        return {};
    }
  }
  return (
    <Dropdown
      className="StoreSelector"
      isOpen={toggle}
      size="sm"
      toggle={() => {
        setToggle(curr => !curr);
      }}
    >
      <DropdownToggle caret className="p-2" style={handleMode(mode)}>
        <span className="ml-2 mr-3">
          {defaultOption}
        </span>
      </DropdownToggle>
      <DropdownMenu
        style={{
          right: globalState.device === 'mobile' ? 'auto' : 0,
          left: globalState.device === 'mobile' ? 0 : 'auto'
        }}
      >
        {options.map(e => (
          <DropdownItem
            key={e.branchCode}
            onClick={() => {
              onSelect({
                branchCode: e.branchCode,
                branchName: e.branchName
              });
            }}
          >
            {e.branchName}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default StoreSelector;
